import React from 'react';
import {
    Card,
    ExamType,
    ExamTable,
    ExamStatus,
    MappedExamStatuses,
    MultiSelectSection,
    IMultiSelectSectionFetchList,
} from 'components';
import { FilteredExamStatus } from 'components/enums';
import { Color, ColorStatus } from '_helpers';
import moment from 'moment';

const Exams = ({
    getList,
    examsList,
    handleRowClick,
    cardTitle,
    cardCategory,
}: IProps) => {
    const [savedFetchData, setSavedFetchData] = React.useState<IMultiSelectSectionFetchList>({});

    const examsTableHeaders = [
        'ДАТА И ВРЕМЯ',
        'КВАЛИФИКАЦИЯ',
        'ТИП ЭКЗАМЕНА',
        'СТАТУС',
    ];

    const createListTableData = (exams: IExam[]) => exams.map((exam) => {
        const createdStatus = MappedExamStatuses[exam.status] || new ColorStatus(Color.Default, exam.status);
        const timeDuff = moment().diff(exam.statusChangeTime, 'days');
        let color = Color.Default;

        if (timeDuff > 7 && timeDuff < 60) {
            color = Color.Orange;
        } else if (timeDuff > 60) {
            color = Color.Red;
        }

        createdStatus.subStatus = {
            color,
            text: exam.statusChangeTime.fromNow(true),
        };

        return ({
            ...exam,
            name: exam.qualificationTitle,
            examType: exam.type,
            status: createdStatus,
        });
    });

    const onRowClick = (itemId: string) => {
        if (handleRowClick) {
            handleRowClick(itemId);
        }

        return true;
    };

    const fetchList = (data: IMultiSelectSectionFetchList) => {
        const nData = { from: data.from, to: data.to, filteredExamStatus: data.filteredExamStatus };

        setSavedFetchData(nData);
        getList(nData);
    };

    return (
        <Card
          title={cardTitle || 'Список экзаменов'}
          category={cardCategory || 'Список экзаменов, связанных с экспертом'}
          cardClassName="border-0"
          withoutPadding
        >
            <MultiSelectSection
              fetchList={fetchList}
              examSelectStatusName="ExpertExamsListFilters"
            />
            <ExamTable
              header={examsTableHeaders}
              tableRows={examsList ? createListTableData(examsList.items) : []}
              onChooseExam={onRowClick}
              onChangePagination={({ page, perPage }) => getList({ ...savedFetchData, page, pageSize: perPage })}
              placeholderTitle="Нет экзаменационной истории"
              placeholderText="Здесь будут отображаться экзамены ЦОК с участием эксперта"
              pagination={examsList}
            />
        </Card>
    );
};

export interface IProps {
    examsList: IList;
    cardTitle?: string;
    cardCategory?: string;
    getList: (data: IGetList) => void;
    handleRowClick?: (id: string) => void;
}

export interface IGetList {
    page?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: boolean;
    from?: moment.Moment;
    to?: moment.Moment;
    filteredExamStatus?: FilteredExamStatus;
}

export interface IList {
    items: IExam[];
    page: number;
    pageSize: number;
    total: number;
}

interface IExam {
    id: string;
    date: moment.Moment;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    qualificationEvaluationCenterName: string;
    examinationCenterName: string;
    address: string;
    city: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    duration: number;
    type: ExamType;
}

export default Exams;
